import _ from 'underscore';
import platformUtilities from '../../modules/platform_utilities.js';
import WaterfallModalHelper from '../../modules/waterfall_modal_helper.js';
import DecimalEnforcer from '../../modules/decimalEnforcer.js';
import DEMAND_CLASSES from '../../modules/demand_classes.js';

angular.module('vastdesk').
  controller('DemandTagFormController', ['$scope', '$timeout', '$interval', '$rootScope', 
    function($scope, $timeout, $interval, $rootScope) {

  var bodySelector = $('body');
  var waterfallModalHelper = new WaterfallModalHelper();
  var decimalEnforcer = new DecimalEnforcer();
  var serverSideTable = $('#tag_results table');
  var modal = $('#tag_modal');
  var modalTable = $('#tag_modal table');
  var modalTableLoaded = $.Deferred();
  var campaignDomIds = "#demand_tag_campaign_id, #programmatic_guaranteed_campaign_id, #selling_strategy_campaign_id";
  var demandPartnerDomIds = "#demand_tag_demand_partner_id, #programmatic_guaranteed_demand_partner_id, #selling_strategy_demand_partner_id";

  $scope.campaignId = 0 ;
  $scope.hasCampaignRate = false;
  $scope.hasCampaignTier = false;
  $scope.demandPartnerId = 0;

  $scope.initDemandPartner = function (demandPartnerId) {
    $scope.demandPartnerId = demandPartnerId;
    var intervalId = $interval(function () {
      var demandPartnerSelect = $(demandPartnerDomIds);
      if (demandPartnerSelect[0] && demandPartnerSelect[0].tomselect) {
        $interval.cancel(intervalId);
        demandPartnerSelect[0].tomselect.on("change", function () {
          $scope.updateDemandPartner();
        });
        setCampaignDisabled();

        // fire on init so we get the data from an existing persisted demand partner
        fetchDemandPartnerData($scope.demandPartnerId, false);
      }
    }, 1);
  };

  $scope.updateDemandPartner = function () {
    $scope.demandPartnerId = $(demandPartnerDomIds).val();
    unsetCampaign();
    setCampaignDisabled();
    fetchDemandPartnerData($scope.demandPartnerId);
  };

  // isChange is used to determine if the demand partner is being changed from the initial load
  var fetchDemandPartnerData = function (demandPartnerId, isChange = true) {
    let campaignTs = $(campaignDomIds)[0].tomselect;
    if(campaignTs) {
      // only load campaigns if a demand partner id is set
      campaignTs.setLoadEnabled(!!demandPartnerId);
      if(!demandPartnerId) {
        // if no demand partner id, don't fetch data
        return;
      }
    }

    // Fetch demand partner data from the API
    fetch(
      "/api/v1/demand_partners/" +
        demandPartnerId +
        "?include=account_managers.user"
    )
      .then((response) => response.json())
      .then((dp) => {
        setAccountManagers(dp);
        updateScopeDefaultTier(dp);
        if (isChange) {
          broadcastDemandPartnerChanged();
          broadcastSequentialLiabilityChange(dp);
        }

        $scope.$apply();
      })
      .catch((error) => {
        console.error("Error fetching demand partner data:", error);
      });
  };

  $scope.setPriceExtensionEnabled = function(val) {
    $scope.priceExtensionEnabled = val;
  };

  bodySelector.on('submit', '.tag-form', function() {
    if ($scope.costModelType !== 0) {
      $scope.setPriceExtensionEnabled(false);
    }
    $scope.$apply();
  });

  $scope.setCostModelType = function(val) {
    if ($scope.usingCampaignRate()) {
      return;
    }
    $scope.costModelType = val;
  };

  $scope.handleOpenrtbGrossFloorRateChange = function() {
    $scope.$broadcast('openrtbGrossFloorRateChange');
  };

  $scope.openrtbNetFloorRate = function() {
    var floorRate = $scope.openrtbGrossFloorRate  * (1 - ($scope.openrtbRevShare/100));
    return isNaN(floorRate) ? 0 : floorRate;
  };

  $scope.setOpenrtbRevShare = function(val) {
    $scope.openrtbRevShare = decimalEnforcer.enforce(val, 'round', 0);
  };

  $scope.changePCFee = function() {
    if ($scope.isPrivateDeal) {
      $scope.setOpenrtbRevShare($scope.pcPrivateDealRevShare);
    } else {
      $scope.setOpenrtbRevShare($scope.pcOriginatedDealRevShare);
    }
  };

  $scope.creativeCompatibleDemandClass = function() {
    return _.includes([DEMAND_CLASSES.CLASS_CREATIVE_ASSET, DEMAND_CLASSES.CLASS_HOUSE_AD], $scope.demandClass);
  };

  $scope.hideRateField = function() {
    return _.includes([DEMAND_CLASSES.CLASS_HEADER_BIDDING, DEMAND_CLASSES.CLASS_HOUSE_AD], $scope.demandClass);
  };

  $scope.hideAdvancedFloors = function () {
    return _.includes([DEMAND_CLASSES.CLASS_HOUSE_AD], $scope.demandClass)
  };

  $scope.houseAdDemandTag = function() {
    return $scope.demandClass === DEMAND_CLASSES.CLASS_HOUSE_AD;
  };

  var initGenerateDealId = function() {
    if (!$scope.dealId || $scope.dealId === '') {
      $scope.generateDealId = true;
    }
  };

  $scope.setOpenrtbType = function(val, disabled) {
    if (disabled === 'disabled') {
      return;
    }
    $scope.openrtbType = val;

    if (val === 'deal_id') {
      initGenerateDealId();
      $scope.changePCFee();
    } else {
      $scope.setOpenrtbRevShare(0);
    }
  };

  $scope.tileLineItem = function() {
    return ([DEMAND_CLASSES.CLASS_LINE_ITEM, DEMAND_CLASSES.CLASS_DIRECT_IO_LINE_ITEM].includes($scope.demandClass) && isTileOrPauseAd());
  };

  $scope.requiredLandingPageUrl = function(publisher) {
    return ([DEMAND_CLASSES.CLASS_CREATIVE_ASSET].includes($scope.demandClass) && (!isTileOrPauseAd() || !publisher));
  };

  $scope.showLandingPageUrlTooltip = function(publisher) {
    return ([DEMAND_CLASSES.CLASS_CREATIVE_ASSET, DEMAND_CLASSES.CLASS_HOUSE_AD].includes($scope.demandClass) && isTileOrPauseAd() && publisher);
  };

  $scope.showAdvertiserDomain = function() {
    return _.includes([DEMAND_CLASSES.CLASS_TAG, DEMAND_CLASSES.CLASS_HEADER_BIDDING], $scope.demandClass) ||
      ($scope.creativeCompatibleDemandClass() && $scope.demandPartnerId) ||
      $scope.tileLineItem();
  };

  bodySelector.on('submit', '#copy_form', function(){
    var copyForm = $(this);
    var path = copyForm.attr('action');
    var demandTagId = copyForm.find('#copy_demand_tag_id').val();
    var params = {
      demand_tag_id: demandTagId,
      demand_partner_id: $scope.demandPartnerId,
      demand_class: $scope.demandClass
    };

    $scope.$broadcast('copySupplyFromDemandSubmit', {
      path: path,
      params: params
    });

    $('#copy_demand_tag_id').val('');
    $('#copy_demand_tag_name').val('');
    $('#copy_save').attr('disabled', true);
    $('#copy_modal').modal('hide');
    return false;
  });

  $rootScope.$on('environmentChange', function(e, args) {
    $scope.environment = args.environment;

    setCreativeLandingPagePlaceholder();
  });

  $rootScope.$on('bidFloorTypeChanged', (e, args) => {
    $scope.bidFloorType = args.bidFloorType;
  });

  $scope.setDemandClass = function(demandClass) {
    if ($('#demand_tag_demand_class_' + demandClass).attr('disabled')) {
      return;
    }
    $scope.demandClass = demandClass;
    setCampaignDisabled();
    showHideHouseAdWfFields();
    setCreativeLandingPagePlaceholder();
    
    if (demandClass === DEMAND_CLASSES.CLASS_HEADER_BIDDING) {
      $('#demand_tag_share_eids_enabled').prop('checked', true);
    }

    $scope.$broadcast('demandClassChanged', {
      demandClass: demandClass
    });
  };

  var setAccountManagers = function (dp) {
    $scope.accountManagers =
      dp.account_managers &&
      dp.account_managers
        .map(
          (accountManager) =>
            accountManager.user.name || accountManager.user.email
        )
        .join(", ");
  };

  var updateScopeDefaultTier = function (dp) {
    $scope.hbUsePartnerDefaultTier = dp.hb_use_default_tier;
    $scope.defaultTier = dp.default_tier;
    if ($scope.defaultTier === 0) {
      $scope.defaultTier = "1L";
    }
  };

  var broadcastDemandPartnerChanged = function () {
    $scope.$broadcast('demandPartnerChanged', {
      demandPartnerId: $scope.demandPartnerId,
    });
  };

  var unsetCampaign = function () {
    $scope.campaignId = null;
    broadcastCampaignChange();

    var campaignSelect = $(campaignDomIds);

    if (campaignSelect[0] && campaignSelect[0].tomselect) {
      // Update the data-ajax attribute of the campaign select with the new demand partner id
      var baseAjaxPath = campaignSelect.data("ajax") || "";
      if (baseAjaxPath) {
        // don't care about the domain of a url object, just the path and query params
        const tmpUrl = new URL(baseAjaxPath, "https://example.com");
        if ($scope.demandPartnerId) {
          tmpUrl.searchParams.set(
            "demand_partner_id",
            $scope.demandPartnerId || ""
          );
        } else {
          tmpUrl.searchParams.delete("demand_partner_id");
        }
        campaignSelect.data("ajax", tmpUrl.pathname + tmpUrl.search);
      }

      // Update the campaign select to clear it out.  Do in timeout to avoid $apply conflicts
      $timeout(
        function () {
          var ts = campaignSelect[0].tomselect;
          ts.clear();
          ts.clearOptions();
          // tom-select will only load empty string search results if the
          // preloaded class is not present already (it gets added after the first load)
          ts.wrapper.classList.remove("preloaded");
          $scope.updateCampaign();
        },
        0,
        false
      );
    }
  };

  $scope.setCampaign = function (campaignId, isDc) {
    $scope.campaignId = campaignId;

    // we need to wait for the tomselect to be initialized
    // so we can put an onChange handler on it
    var intervalId = $interval(function () {
      var campaignSelect = $(campaignDomIds);
      if (campaignSelect[0] && campaignSelect[0].tomselect) {
        $interval.cancel(intervalId);
        campaignSelect[0].tomselect.on("change", function () {
          $scope.updateCampaign();
        });

        broadcastCampaignChange();
        if (isDc) {
          $scope.updateDcCampaign();
        } else {
          $scope.updateCampaign();
        }
      }
    }, 1);
  };

  var broadcastCampaignChange = function() {
    $scope.$broadcast('campaignChanged', {
      campaignId: $scope.campaignId
    });
  };

  var updateRateCurrencyChosen = function() {
    setTimeout(function() {
      $("select[name*='[rate_currency]']").trigger('chosen:updated');
    }, 0);
  };

  var setRate = function(rate, currency) {
    if ($scope.usingCampaignRate()) {
      $scope.rate = rate;
      $scope.rateCurrency = currency;
      updateRateCurrencyChosen();
    }
  };

  $(document).ready(function () {
    $('#programmatic_guaranteed_inventory_groups_attributes_0_inventory_values').on('change', function (...args) {
      let valueSelected = this.value;

      $('#programmatic_guaranteed_inventory_groups_attributes_0__destroy').val(valueSelected === '');
    });
  });

  var fetchCampaignData = function (campaignId) {
    // Fetch campaign data from the API
    fetch(
      "/api/v1/campaigns/" +
        campaignId +
        "?include=targeting_time_profile,targeting_spend_profile"
    )
      .then((response) => response.json())
      .then((campaign) => {
        $scope.hasCampaignRate = campaign.rate > 0;
        $scope.hasCampaignTier = campaign.demand_tiering;

        broadcastCampaignActive(campaign.is_active);
        broadcastCampaignHasRate($scope.hasCampaignRate);

        $rootScope.$broadcast("campaignDatesChange", campaign);

        $rootScope.currentCampaignBudgets = (campaign.targeting_spend_profile || {}).budgets || [];
        $rootScope.$broadcast("campaignBudgetsChange", {
          budgets: $rootScope.currentCampaignBudgets
        });
        if ($scope.hasCampaignRate) {
          setRate(parseFloat(campaign.rate), campaign.rate_currency || "USD");
          $scope.bookedRevenue = parseFloat(campaign.booked_revenue);
        }

        $scope.$apply();
      })
      .catch((error) => {
        console.error("Error fetching campaign data:", error);
      });
  };

  $scope.updateCampaign = function () {
    $timeout(function () {
      var campaignSelect = $(campaignDomIds);
      var selectedValue = campaignSelect.val();

      // Always update the scope first
      $scope.campaignId = selectedValue;

      // Use $timeout to ensure this runs after any pending digest cycles
      $timeout(function () {
        broadcastCampaignChange();

        if (!selectedValue || selectedValue == "") {
          broadcastCampaignActive(true);
          $rootScope.currentCampaignBudgets = [];
          $rootScope.$broadcast("campaignBudgetsChange", { budgets: [] });
          $scope.hasCampaignRate = false;
          $scope.hasCampaignTier = false;
          $scope.rate = $scope.demandTagRate;
          $scope.rateCurrency = $scope.demandTagRateCurrency;
          $scope.bookedRevenue = $scope.demandTagBookedRevenue;
          updateRateCurrencyChosen();
        } else {
          // Always fetch campaign data from server
          fetchCampaignData(selectedValue);
        }
      }, 0);
    });
  };

  $scope.updateDcCampaign = function () {
    var selected = $(campaignDomIds).find("option:selected");
    broadcastCampaignChange();

    if (selected.length <= 0) {
      return;
    } else if (selected[0].value == "") {
      broadcastCampaignActive(true);
    } else {
      // search results put inactive campaigns in an <em> tag
      // so check for the closing </em> tag as proxy for inactive
      broadcastCampaignActive(!selected.text().includes("</em></a>"));
    }
  };

  var broadcastCampaignActive = function (value) {
    $rootScope.$broadcast('campaignActiveChange', {
      campaignActive: value
    });
  };

  var broadcastSequentialLiabilityChange = function (dp) {
    $rootScope.$broadcast('sequentialLiabilityChange', {
      // sequential_liability_approved is only supplied by the demand partner serializer
      // if enabled on the account, so its implicitly approved if not present,
      // otherwise check if it's explicitly true
      approved:
        !Object.prototype.hasOwnProperty.call(
          dp,
          'sequential_liability_approved'
        ) || dp.sequential_liability_approved === true,
    });
  };

  var broadcastCampaignHasRate = function (value) {
    $rootScope.$broadcast('campaignHasRateChange', {
      hasRate: value
    });
  };

  $scope.hidePriceExtensionEnabled = function() {
    return $scope.costModelType !== 0 || $scope.hasCampaignRate || !_.includes([DEMAND_CLASSES.CLASS_TAG, DEMAND_CLASSES.CLASS_LINE_ITEM], $scope.demandClass);
  };

  $scope.usingCampaignRate = function() {
    return $scope.hasCampaignRate;
  };

  $scope.hideCampaignTier = function() {
    return !$scope.hasCampaignTier;
  };

  $scope.usingCampaignRateTooltip = function() {
    if ($scope.usingCampaignRate()) {
      return 'Using Campaign rate and payment terms';
    }
  };

  $scope.doohEnvironmentSelected = function() {
    return _.includes(['dooh'], $scope.environment);
  };

  serverSideTable.on('preXhr.dt', function (e, settings, data) {
    data.campaign_id = $scope.campaignId;
    data.demand_partner_id = $scope.demandPartnerId;
    data.demand_class = $scope.demandClass;
    data.hb_use_partner_default_tier = $scope.hbUsePartnerDefaultTier;
    data.default_tier = $scope.defaultTier;
    data.openrtb_type = $scope.openrtbType;
    data.rate = $scope.openrtbNetFloorRate();
  });

  modalTable.on('preXhr.dt', function(e, settings, data) {
    data.custom_data = data.custom_data || {};
    data.custom_data.demand_tag = {
      dc_open_rtb: $scope.isDcOpenRtb,
      openrtb_type: $scope.openrtbType,
      openrtb_gross_floor_rate: $scope.openrtbNetFloorRate(),
      vast_endpoint_url: $('#demand_tag_vast_endpoint_url').val(),
      demand_class: $scope.demandClass
    };
  });

  modalTable.on('init.dt', function () {
    modalTableLoaded.resolve();
  });

  modalTable.on('draw.dt', function () {
    _styleModalRows();
  });

  waterfallModalHelper.openEventHandler(bodySelector, '.open-tag-modal', modal, modalTable, function() {
    $.when( modalTableLoaded ).done(function() {
      _setFloorRpmFilter();
    });
  });

  waterfallModalHelper.saveEventHandler(bodySelector, modal, modalTable, function() {
    var params = {
      demand_partner_id: $scope.demandPartnerId,
      demand_class: $scope.demandClass
    };

    $scope.$broadcast('addSupplyModalSave', {
      params: params
    });
  });

  var demandTagFormat = function() {
    return $('input[name="demand_tag[format]"]:checked').val() || 'video';
  };

  var isTileOrPauseAd = function() {
    return ['tile', 'pause_ad'].includes(demandTagFormat());
  };

  $("#copy_demand_tag_name").autocomplete({
    minLength: 1,
    source: function( request, response ) {
      $.ajax({
        url: "/searches/demand_tags?text_only=true&exclude_open_market=true&format=" + demandTagFormat() + "&search="+request.term,
        dataType: "json"
      }).done(function( data ) {
        response(
          _.chain(data)
           .map(function(item) {
             return {
               label: item.text,
               value: item.value
             };
           })
           .reject(function(item) {
             return item.value == $scope.demandTagId;
           })
           .value()
        );
      });
    },
    select: function(e, ui){
      var item = ui.item;
      var itemId = item.value;
      $("#copy_demand_tag_name").val($('<div></div>').html(item.label).text());
      $("#copy_demand_tag_id").val(itemId);
      $("#copy_save").removeAttr("disabled");
      return false;
    }
  }).data("ui-autocomplete")._renderItem = function (ul, item) {
     return $("<li></li>")
         .data("item.autocomplete", item)
         .append(item.label)
         .appendTo(ul);
   };

  var _styleModalRows = function (){
    var bulkIndex = modalTable.find("th.bulk-add-enabled").index();
    var statusIndex = modalTable.find("th.status").index();

    modalTable.find("tr").each(function(i, tr) {
      waterfallModalHelper.styleWithBulkAddEnabled(tr, bulkIndex);
      waterfallModalHelper.styleStatus(tr, statusIndex);
    });
  };

  $rootScope.$on('formatChanged', function(e, args) {
    if (['tile', 'pause_ad', 'display'].includes(args.format) && $scope.costModelType == 3) {
      $scope.setCostModelType(0);
    }
  });

  var hasDynamicBidFloorRate = function() {
    return _.includes([DEMAND_CLASSES.CLASS_HEADER_BIDDING], $scope.demandClass) &&
      $('input[name="demand_tag[bid_floor_type]"]:checked').val() === 'dynamic';
  };

  var hasPerformancePricing = function() {
    return _.includes([2, 3], $scope.costModelType);
  };

  var isDealId = function() {
    return $scope.isDcOpenRtb && $scope.openrtbType === 'deal_id';
  };

  var _rateFilterRate = function() {
    var rate = $("#demand_tag_rate, #selling_strategy_rate").val();
    if (isDealId()) {
      rate = String($scope.openrtbNetFloorRate());
    }
    return rate;
  };

  var _setFloorRpmFilter = function () {
    var filterVal = '';
    var rate = platformUtilities.cleanParseFloat(_rateFilterRate());
    if (rate) {
      filterVal = (hasDynamicBidFloorRate() || hasPerformancePricing()) ? '' : rate.toFixed(2);
    }
    modal.find("#dfilter_rpm_floor").val(filterVal).trigger("keyup");
    modal.find('#dfilter_min_rpm_floor').val('').trigger("keyup");
  };

  var setCreativeLandingPagePlaceholder = function() {
    // cannot use angular because the input has ng-non-bindable
    var placeholder = 'No URL entered';

    if ($scope.environment === 'ctv' || _.includes([DEMAND_CLASSES.CLASS_TAG, DEMAND_CLASSES.CLASS_HEADER_BIDDING], $scope.demandClass)) {
      placeholder = 'For use in advertiser domain targeting';
    }

    $('#demand_tag_creative_landing_page_url').attr('placeholder', placeholder);
  };

  var setCampaignDisabled = function () {
    const campaignDisabled = $scope.houseAdDemandTag() || !$scope.demandPartnerId || DEMAND_CLASSES.CLASS_UNIFIED_DEMAND_AD_SOURCE === $scope.demandClass;
    $(campaignDomIds).attr('disabled', campaignDisabled);
    campaignDisabled ? $(campaignDomIds).get(0)?.tomselect?.disable() : $(campaignDomIds).get(0)?.tomselect?.enable();
  };

  var toggleHouseAdColumns = function(cols, toggle) {
    $('#tag_results table').find(cols).toggleClass('hidden-column', toggle).css('display', 'table-cell');
  };

  var showHideHouseAdWfFields = function() {
    if ($scope.persisted) {
      return;
    }
    toggleHouseAdColumns('th.ratio, th.weight', !$scope.houseAdDemandTag());
    toggleHouseAdColumns('th.tier, th.priority', $scope.houseAdDemandTag());
  };

  setTimeout(function () {
    setCreativeLandingPagePlaceholder();
    setCampaignDisabled();
    showHideHouseAdWfFields();
  }, 0);
}]);
